module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0011.jpg?v=7651f9a2";